import SidebarLayout from "../components/SidebarLayout.tsx";
import { useMyStudioSections } from "../hooks/useMyStudioSections.ts";

export default function MyStudio() {
  const sections = useMyStudioSections();

  return <SidebarLayout sections={sections} />;
}
